import React from 'react';
import Button from "components/button";

const Footerbutton = ({pi,nationality,formIndex,oC1,oC2,oC3,oC4,oC5,oC6}) => {
    const test = pi || nationality
    
    // Pour NUE : Pages 1-5 = Suivant, Page 6 = Confirmer
    const elementsNUE=[
        <Button key={0} size={'LG'} onClick={oC1}>Suivant</Button>, // Page 1
        <Button key={1} size={'LG'} onClick={oC1}>Suivant</Button>, // Page 2
        <Button key={2} size={'LG'} onClick={oC1}>Suivant</Button>, // Page 3
        <Button key={3} size={'LG'} onClick={oC1}>Suivant</Button>, // Page 4
        <Button key={4} size={'LG'} onClick={oC1}>Suivant</Button>, // Page 5
        <Button key={5} size={'LG'} onClick={oC2}>Confirmer</Button>, // Page 6
    ]

    // Pour UE : Pages 1-3 = Suivant, Page 4 = Confirmer
    const elementsUE=[
        <Button key={0} size={'LG'} onClick={oC1}>Suivant</Button>, // Page 1
        <Button key={1} size={'LG'} onClick={oC1}>Suivant</Button>, // Page 2
        <Button key={2} size={'LG'} onClick={oC1}>Suivant</Button>, // Page 3
        <Button key={3} size={'LG'} onClick={oC2}>Confirmer</Button>, // Page 4
    ]
    
    return (
        <>
            {(test === 'NUE' ? elementsNUE : elementsUE).filter(
                (item,index) => index+1 === formIndex)
            }
        </>
    );
};

export default Footerbutton;